// A deploy replaces the hashed asset files a stale tab still references, so
// fetching a chunk after that point fails with one of these browser/bundler
// messages. Reloading once fetches the current index.html and its up-to-date
// chunk manifest; the cooldown guard stops a reload loop if reloading doesn't
// help (e.g. a genuinely broken deploy).
const STALE_CHUNK_PATTERN =
  /loading chunk|failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed/i;
const RELOAD_COOLDOWN_MS = 10_000;
const LAST_RELOAD_KEY = 'stale-chunk-reload-at';

export default function reloadOnStaleChunk(
  message: string | undefined,
): boolean {
  if (!message || !STALE_CHUNK_PATTERN.test(message)) {
    return false;
  }
  const lastReload = Number(sessionStorage.getItem(LAST_RELOAD_KEY) || 0);
  if (Date.now() - lastReload < RELOAD_COOLDOWN_MS) {
    return false;
  }
  sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
  window.location.reload();
  return true;
}
